import React, { useState, useRef } from 'react';
import EditableTag from '../../../crm/shared/field_inputs/shared/EditableTag';
import ItemsAppender from '../../../crm/shared/field_inputs/item_list/ItemsAppender';
import SpinLoader from '../../../crm/shared/field_inputs/shared/SpinLoader';
import { deleteItem, focusRef } from '../../../crm/shared/field_inputs/shared/EventHelpers';

const ExlEditItemList = ({
    iconName,
    value: items,
    setValue: setItems,
    onKeyDown,
    getSuggestions,
    isCreationPermitted,
    isInvalid,
    autoFocus,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const inputRef = useRef();
    //Drag And Drop Bookings
    const dragItem = useRef();
    const dragOverItem = useRef();

    const dragStart = (e, position) => {
        dragItem.current = position;

    };
    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };
    const drop = (e) => {
        const copyListItems = [...items];
        const dragItemContent = copyListItems[dragItem.current];
        copyListItems.splice(dragItem.current, 1);
        copyListItems.splice(dragOverItem.current, 0, dragItemContent);
        dragItem.current = null;
        dragOverItem.current = null;
        setItems(copyListItems);
        //setList(copyListItems);
    }

    return (
        <div className='crm-editable-field-wrapper'>
            <div className={`input-wrapper ${isInvalid ? 'invalid' : ''}`} onClick={() => focusRef(inputRef)}>
                {items &&
                    items.map((item, index) => (
                        <div className='d-flex justify-content-between' key={item.id ? item.id : index}
                            onDragStart={(e) => dragStart(e, index)}
                            onDragEnter={(e) => dragEnter(e, index)}
                            onDragEnd={drop}
                            draggable>
                            <EditableTag
                                label={item.name === undefined ? item.coaEmpName : item.name}
                                handleDelete={() => deleteItem(items, setItems, item)}
                            />
                            {item.id === null ? <div className='new-badge' /> : null}
                        </div>
                    ))}
                <ItemsAppender
                    {...{ iconName, items, setItems, setIsLoading, onKeyDown, getSuggestions, isCreationPermitted, inputRef, autoFocus }}
                />
                <SpinLoader isLoading={isLoading} />
            </div>
        </div>
    );
};

export default ExlEditItemList;
